const pythonLintMessages = {
    "unused-variable": "Variável declarada, mas nunca utilizada. Verifique se você realmente precisa dela.",
    "function-definition": "Função declarada, mas nunca usada. Certifique-se de chamá-la ou remova-a.",
    "syntax-error": "Problema de indentação ou erro de sintaxe detectado. Verifique a estrutura do código.",
    "print-statement": "Evite o uso de print() em produção. Substitua por logs estruturados.",
    "missing-return": "Função sem retorno explícito. Adicione um retorno ou ajuste a lógica.",
    "undefined-variable": "Variável usada, mas não declarada. Declare a variável antes de utilizá-la.",
    "redefined-variable": "Variável redefinida no mesmo escopo. Escolha nomes únicos para evitar conflitos.",
    "no-self-argument": "Métodos de classe precisam incluir 'self' como o primeiro argumento.",
    "trailing-whitespace": "Remova os espaços em branco no final da linha para manter o código limpo.",
    "line-too-long": "A linha está muito longa. Divida-a em várias linhas para melhor legibilidade.",
    "module-docstring-missing": "Inclua uma docstring no início do módulo para documentar sua funcionalidade.",
    "class-docstring-missing": "Classes devem ter docstrings explicando sua funcionalidade.",
    "method-docstring-missing": "Métodos de classe devem ter docstrings explicando sua funcionalidade.",
    "variable-name": "Nomes de variáveis devem seguir o padrão snake_case.",
  };
  
  export default pythonLintMessages;
  